import React from 'react'
import { useStore } from '../../store/store';
import { useTranslation } from 'react-i18next';
import { iconButtonStyle } from '../../utils/styles';
import { NavbarButton } from '../Layout/NavbarButton';
import DuotoneLightIcon from '../common/DuotoneLightIcon';

const selector = (id) => ({
  containers,
  removeContainer,
  removeSectionContainers,
  boxes,
  maskEditing,
  masks,
  updateContainer,
  currentProposal,
}) => {
  const container = containers.find((c) => c.id === id);
  const mask = !container && maskEditing.length > 0
    && maskEditing.includes(id)
    && masks.find((m) => m.id === id);
  return {
    container: container,
    removeContainer,
    removeSectionContainers,
    updateContainer,
    currentProposal,
    hasBox: !mask && boxes.some((b) => container.columnsIds.includes(b.columnId)),
  }
};

const EditableContainerButton = ({ id }) => {
  const {
    container,
    updateContainer,
    currentProposal,
  } = useStore(selector(id));
  const { t } = useTranslation();

  const editableContainer = () => {
    updateContainer({
      id: container.id, fn: (container) => {
        if (!container.hasOwnProperty('editable')) {
          container.editable = false;
        } else {
          container.editable = !container.editable;
        }
      }
    })
  }

  const isUnlocked = container.editable || !container.hasOwnProperty('editable')
  const showButton = !(currentProposal.id !== null && (typeof container?.editable !== 'boolean' || container?.editable))

  if (!showButton) return null;

  return (
    <NavbarButton
      tooltipContent={t(isUnlocked ? 'unblock-editable-container' : 'block-editable-container')}
      onClick={editableContainer}
      disabled={currentProposal.id !== null || container?.from_linked_section}
      icon={isUnlocked ?
        <DuotoneLightIcon name='lock-keyhole-open' style={iconButtonStyle()} /> :
        <DuotoneLightIcon name='lock-keyhole' style={iconButtonStyle()} />}
    />
  )
}

export default EditableContainerButton;
